var EResourceType;

(function (EResourceType) {
  /** 音频  */
  EResourceType[EResourceType["Sound"] = 1] = "Sound";
  /** 图片  */

  EResourceType[EResourceType["Image"] = 2] = "Image";
  /** 音频弹幕 */

  EResourceType[EResourceType["DanmakuInSound"] = 3] = "DanmakuInSound";
  /** 用户 */

  EResourceType[EResourceType["User"] = 4] = "User";
  /** 直播 */

  EResourceType[EResourceType["Live"] = 5] = "Live";
  /** 父评论 */

  EResourceType[EResourceType["Comment"] = 6] = "Comment";
  /** 子评论 */

  EResourceType[EResourceType["SubComment"] = 7] = "SubComment";
  /** 私信 */

  EResourceType[EResourceType["DirectMessage"] = 8] = "DirectMessage";
  /** 音单 */

  EResourceType[EResourceType["SoundList"] = 9] = "SoundList";
  /** 互动剧节点弹幕 */

  EResourceType[EResourceType["DanmakuInDrama"] = 10] = "DanmakuInDrama";
})(EResourceType || (EResourceType = {}));

var EReportReason;

(function (EReportReason) {
  /** 广告 */
  EReportReason[EReportReason["Advertisement"] = 1] = "Advertisement";
  /** 色情 */

  EReportReason[EReportReason["Pornography"] = 2] = "Pornography";
  /** 版权 */

  EReportReason[EReportReason["CopyrightInfringement"] = 3] = "CopyrightInfringement";
  /** 政治 */

  EReportReason[EReportReason["Politic"] = 4] = "Politic";
  /** 其他 */

  EReportReason[EReportReason["Other"] = 5] = "Other";
})(EReportReason || (EReportReason = {}));

export { EReportReason, EResourceType };
